export const Enum = {

  AgGridActions: {

    Add: 1,
    Edit: 2,
    Display: 3,
    Delete: 4,
    Setting: 5,
    Tracking: 6,
    UserRole: 7,
    Additional: 8,
    scanAndPack: 9,
    logisticFailed: 10,

  },

  orderActions: {
    customer: "Customer / Billing Information",
    shipping: "Shipping Information",
    order: "Order Information",
    orderRemarks: "Order Remarks",
    attachment: "Attachment",
  },

  logSource: {
    order: "Order",
    customer: "Customer",
    product: "Product",
    orderStatus: "Order Status",
    applyLogistic: "Apply Logistic"
  },

  logTypes: {
    order: 1,
    customer: 2,
    product: 3,
    productStock: 4,
    role: 5,
    roleGroup: 6,
    invitation: 7,
    shippingCarrier: 8,
    orderStatus: 9,
  },

  importType: {
    Products: "Products",
    Orders: "Orders",
    Customers: "Customers",
  },

  statusCode: {
    unauthorized: 401
  },

  captions: {
    add: 'Add',
    update: 'Update',
    submit: 'Submit',
    connect: 'Connect',
  },
  userStatus: {
    active: 'Active',
    inActive: 'inActive',
    owner: 'Active (Owner)',
  },


  invitationStatus: {
    Invited: 0,
    Accepted: 10,
    Rejected: 20,
    Revoked: 100,
    Active: 200,
    InActive: 250,
  },

  systemRoles: {
    SysAdmin: 1,
    AppUser: 2,
    CompanyOwner: 3,
    CompanyAdmin: 4,
    CompanyUser: 5,
    GeneralUser: 6
  },
  controller: {
    Company: 'Company',
    user: 'user',
    ShippingSource: 'ShippingSource',
    SellingChannel: 'SellingChannel',
    SmsServiceProvider: 'SmsServiceProvider'
  },

  paymentType: {
    cod: 'Cash on delivery',
    coc: 'Credit Card',
  },

  DiscountType: {
    Percent: 0, // Default
    Amount: 1,
  },

  productType: {
    product: 'Product',//10,
    services: 'Services',//20,
    bundle: 'Bundle',//30,
    productVariant: 'Product Variant'//40
  },

  importProductType: {
    product: 'product',
    variant: 'variant',
    services: 'Services'
  },

  subscriptionPlanType: {
    subscription: '0',
    addon: '1',
  },

  subscriptionPromoType: {
    signup: '0',
    upgrade: '1',
    renewal: '2',
  },

  paymentMode: {
    onlineTransfer: 0,
    creditCard: 1,
  },

  paymentStatus: {
    unpaid: 0,
    paid: 1,
  },

  subscriptionStatus: {
    pending: 0,
    activated: 1,
    expired: 2
  },

  planSequence: {
    planSequence: "planSequence"
  },

  statusType: {

    isInProcess: "isInProcess",
    isPause: "isPause",
    isBooked: "isBooked",
    isForShipment: "isForShipment",
    isDispatched: "isDispatched",
    isInTransit: "isInTransit",
    isDelivered: "isDelivered",
    isReturned: "isReturned",
    isCompleted: "isCompleted",
    isCancelled: "isCancelled"
  },

  ActionType: {

    SMS: 1,
    Status: 2,
    Email: 3
  },

  DateRangeType: {
    from: 'from',
    to: 'to'
  },

  screenType: {
    saleReturnScreen: 1,
    discrepancyReportScreen: 2,
    taskMonitorScreen: 3,
  },

  labelText: {
    resolve: "Resolve",
    verify: "Verify",
    verified: "Verified",
    unVerify: "Unverify",
    resolved: "Resolved",
  },

  productStatus: {
    active: "active",
    draft: "draft",
    publish: "publish"
  },

  documentSourceType: {
    skd: "skd",
    destination: "destination",
    sellingChannel: "sellingChannel",
    shippingCarier: "shippingCarier"
  },

  fileType: {
    pdf: "pdf",
    excel: "excel"
  },

  seriesNumberEntities: {
    product: 1,
  },

  defaultAutoGeneratedSku: {
    lastNumber: "SKD-000001",
    prefix: "SKD",
  }

};
